const styles = theme => ({
  card: {
    borderRadius: '16px',
    background: '#fff',
    padding: '0',
    height: '240px',
    display: 'flex',
    fontFamily: theme.font.family.secondary,
    color: theme.palette.dark,
    overflow: 'hidden',

    [theme.breakpoints.down('sm')]: {
      height: 'initial',
    },
  },
  content: {
    flex: 1,
    display: 'flex',
    alignSelf: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  blockText: {
    display: 'flex',
    alignSelf: 'center',
    flexDirection: 'column',
    flex: 1,
    padding: '24px',
    width: '100%',
  },
  title: {
    fontSize: theme.font.sizes.md,
    fontWeight: theme.font.weights.bold,
    margin: 0,
  },
  description: {
    fontSize: theme.font.sizes.sm,
    lineHeight: '1.5',
    margin: 0,
    marginTop: '16px',
  },
  actions: {
    textAlign: 'left',
    marginTop: '16px',
  },
  blockImage: {
    [theme.breakpoints.up('sm')]: {
      marginRight: '-24px',
    },

    [theme.breakpoints.down('sm')]: {
      margin: '0',
      marginBottom: '-16px',
    },
  },
  Image: {
    width: '100%',
    height: '-webkit-fill-available',
  },
});

export default styles;
